import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "type", "icon", "id", "as", "isDisabled", "isLoading", "isSelected", "onClick", "onBlur", "title", "variant", "mode", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import { StyledIconButton } from './IconButton.styles';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import Icon from '../Icon';
import Spinner from '../Spinner';
import { jsx as _jsx } from "react/jsx-runtime";
var iconSizes = {
  small: 12,
  medium: 14,
  large: 16
};
var IconButton = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      icon = _ref.icon,
      id = _ref.id,
      as = _ref.as,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isLoading = _ref.isLoading,
      isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      onClick = _ref.onClick,
      onBlur = _ref.onBlur,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
      _ref$mode = _ref.mode,
      mode = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var iconSize = iconSizes[size] || size;
  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-icon-button"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  return _jsx(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: _jsx(StyledIconButton, _objectSpread(_objectSpread({
      ref: ref,
      className: className,
      variant: variant,
      id: id,
      as: as,
      isLoading: isLoading,
      isSelected: isSelected,
      disabled: isDisabled || isLoading,
      "aria-disabled": isDisabled || isLoading,
      "aria-label": title,
      title: title,
      onClick: onClick,
      onBlur: onBlur,
      type: type
    }, rest), {}, {
      children: isLoading ? _jsx(Spinner, {
        size: size
      }) : _jsx("span", {
        className: "".concat(prefix, "-icon-button__icon"),
        children: _jsx(Icon, {
          icon: icon,
          size: iconSize
        })
      })
    }))
  });
});
export default IconButton;